import { render, staticRenderFns } from "./add-comment.vue?vue&type=template&id=128594f8&scoped=true&"
import script from "./add-comment.vue?vue&type=script&lang=js&"
export * from "./add-comment.vue?vue&type=script&lang=js&"
import style0 from "./add-comment.vue?vue&type=style&index=0&id=128594f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128594f8",
  null
  
)

export default component.exports